
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 11 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 .984H0v4h4v-4zM11 .984H7v4h4v-4zM4 7.984H0v4h4v-4zM11 7.984H7v4h4v-4zM4 14.984H0v4h4v-4zM11 14.984H7v4h4v-4z","fill":"currentColor"}})])
          )
        }
      }
    